import { Button } from '@modules/common/components';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

interface UnsavedChangesDialogContentProps {
  actionText: string;
  onCancel: () => void;
  onSave: () => void;
}

export const UnsavedChangesDialogContent = ({
  actionText,
  onCancel,
  onSave,
}: UnsavedChangesDialogContentProps) => {
  return (
    <>
      <DialogTitle>Save changes to {actionText}</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>
          <Typography>
            You have unsaved changes. Please save before you {actionText}.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Stack direction="row" m={1} spacing={2}>
          <Button onClick={onCancel} variant="outlined">
            Cancel
          </Button>
          <Button onClick={onSave} variant="contained" autoFocus>
            Save
          </Button>
        </Stack>
      </DialogActions>
    </>
  );
};
